var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinsGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coins"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 3.5C15 4.88071 11.866 6 8 6C4.13401 6 1 4.88071 1 3.5M15 3.5C15 2.11929 11.866 1 8 1C4.13401 1 1 2.11929 1 3.5M15 3.5V15.5C15 16.8807 11.866 18 8 18C4.13401 18 1 16.8807 1 15.5V3.5M15 7.5C15 8.88071 11.866 10 8 10C4.13401 10 1 8.88071 1 7.5M15 11.5C15 12.8807 11.866 14 8 14C4.13401 14 1 12.8807 1 11.5",
    stroke: "#EBC600",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsGold);
export default __webpack_public_path__ + "static/media/CoinsGold.ddddcd27dfecdbed6ebd35485557c7d5.svg";
export { ForwardRef as ReactComponent };